import React, { PropsWithChildren } from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import { useQuery } from '@tanstack/react-query';
import ParityService from '@app/model/parity/service/ParityService';
import { ParityQueryKeys } from '@app/model/parity/service/ParityQueryKeys';
import ParitySnapshot from '@app/model/parity/ParitySnapshot';
import ParityFilterInput from '@app/model/parity/input/ParityFilterInput';
import CalendarRange from '@app/state/calendar/CalendarRange';

export const MarketStateParityForPeriodContext = React.createContext<ParitySnapshot | undefined>(undefined);

const MarketStateParityForPeriodProvider: React.FunctionComponent<PropsWithChildren<{
	companyHotel: CompanyHotel,
	range: CalendarRange,
	parityFilter: ParityFilterInput
	loadingPlaceholder: React.ReactNode
}>> = ({ companyHotel, range, parityFilter, loadingPlaceholder, children }) => {

	const parityQuery = useQuery({
		queryFn: () => ParityService.findParityForPeriod(companyHotel.id, range.startStatDate, range.endStatDate, parityFilter),
		queryKey: ParityQueryKeys.periods(companyHotel.id, range.startStatDate, range.endStatDate, parityFilter),
		refetchOnWindowFocus: false,
	});

	if (parityQuery.isLoading) return loadingPlaceholder;

	if (parityQuery.isSuccess) {
		return <MarketStateParityForPeriodContext.Provider
			value={parityQuery.data}>{children}</MarketStateParityForPeriodContext.Provider>;

	} else return <></>;
};

export default MarketStateParityForPeriodProvider;